import { gql, useQuery } from '@apollo/client';
import { Box, Button, Center, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { ECommunityAccessConfig } from '@/graphql-types/globalTypes';
import { Card } from '@/imports/ui/chakra/components/Card';
import { Trash2Icon } from '@/imports/ui/chakra/feather';

import { PostRemovedCard_CurrentUser_Tenant } from './graphql-types/PostRemovedCard_CurrentUser_Tenant';

const USER_QUERY = gql`
  query PostRemovedCard_CurrentUser_Tenant {
    currentUser {
      _id
      canAccessCommunity
    }
    tenant {
      result {
        _id
        communityAccessConfig
      }
    }
  }
`;

export const PostRemovedCard: React.FC = () => {
  const { data } = useQuery<PostRemovedCard_CurrentUser_Tenant>(USER_QUERY);

  const isVisitingPublicCommunityWhileLoggedOut =
    data?.tenant.result?.communityAccessConfig ===
      ECommunityAccessConfig.PUBLIC && !data?.currentUser;

  const canAccessCommunity =
    data?.currentUser?.canAccessCommunity ||
    isVisitingPublicCommunityWhileLoggedOut;

  return (
    <Card width="full">
      <Center h={96}>
        <Box textAlign="center">
          <Trash2Icon />
          <Text fontWeight="semibold" color="gray.700">
            This post has been removed
          </Text>
          {!!canAccessCommunity && (
            <Text color="gray.600">
              Check out new activity on the home feed!
            </Text>
          )}
          <NextLink href="/">
            <Button mt="4">Back to Home</Button>
          </NextLink>
        </Box>
      </Center>
    </Card>
  );
};
